import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Breadcrumb } from '../../../../core/model';

@Component({
  selector: 'py-catalog-filter-reset',
  templateUrl: './catalog-filter-reset.component.html',
  styleUrls: ['./catalog-filter-reset.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CatalogFilterResetComponent {
  @Input() breadcrumbs: Breadcrumb[];
  @Input() productUrl?: string;
  @Input() showIconRight = true;

  @Output() resetFacets = new EventEmitter<void>();

  onResetFacets(): void {
    this.resetFacets.emit();
  }
}
